import axios from "axios";
import { useState } from "react";
import { RequiredStar } from "../RequiredStar.js/RequiredStar";
import { handleToastr } from "@litonarefin/utils/handleToastr";

export const ContactFormForDocs = () => {
    const [spinner, setSpinner] = useState(false);
    const [formInfo, setFormInfo] = useState({
        names: {
            first_name: "",
            last_name: "",
        },
        email: "",
        subject: "",
        website: "",
        message: "",
        site_source: process.env.NEXT_PUBLIC_SOURCE_SITE,
    });

    const handleOnChange = (e) => {
        let key = e.target.name;
        let value = e.target.value;
        if (key == "first_name" || key == "last_name") {
            setFormInfo({
                ...formInfo,
                names: { ...formInfo.names, [key]: value },
            });
        } else {
            setFormInfo({ ...formInfo, [key]: value });
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSpinner(true);
        let { data } = await axios.post(`/api/contact`, formInfo);
        if (data?.success) {
            setSpinner(false);
            handleToastr("Form Submitted Successfully!");
            setFormInfo({
                names: {
                    first_name: "",
                    last_name: "",
                },
                email: "",
                subject: "",
                website: "",
                message: "",
                site_source: process.env.NEXT_PUBLIC_SOURCE_SITE,
            });
        }
    };

    return (
        <div className="jlt-bg-[#FFFFFF] jlt-rounded-lg jlt-p-8">
            <form action="">
                <div className="jlt-mb-6 jlt-grid jlt-grid-cols-2 jlt-gap-5">
                    <div>
                        <label
                            htmlFor="first_name"
                            className="jlt-block jlt-text-[#3F475A] jlt-text-sm">
                            First Name <RequiredStar />
                        </label>
                        <input
                            type="text"
                            name="first_name"
                            id="first_name"
                            value={formInfo.names.first_name}
                            onChange={handleOnChange}
                            className="jlt-w-full jlt-h-[40px] jlt-bg-[#FCFDFF] jlt-border-[1px] jlt-border-[#EBEEF5] jlt-rounded-[2px] jlt-mt-2 jlt-px-5 jlt-outline-none jlt-text-sm jlt-text-[#3F475A]"
                        />
                    </div>
                    <div>
                        <label
                            htmlFor="last_name"
                            className="jlt-block jlt-text-sm jlt-text-[#3F475A]">
                            Last Name <RequiredStar />
                        </label>
                        <input
                            type="text"
                            name="last_name"
                            id="last_name"
                            value={formInfo.names.last_name}
                            onChange={handleOnChange}
                            className="jlt-w-full jlt-h-[40px] jlt-bg-[#FCFDFF] jlt-border-[1px] jlt-border-[#EBEEF5] jlt-rounded-[2px] jlt-mt-2 jlt-px-5 jlt-outline-none jlt-text-[#3F475A]"
                        />
                    </div>
                </div>
                <div className="jlt-mb-6">
                    <label htmlFor="email" className="jlt-block jlt-text-[#3F475A] jlt-text-sm">
                        Email <RequiredStar />
                    </label>
                    <input
                        type="email"
                        name="email"
                        id="email"
                        value={formInfo.email}
                        onChange={handleOnChange}
                        className="jlt-w-full jlt-h-[40px] jlt-bg-[#FCFDFF] jlt-border-[1px] jlt-border-[#EBEEF5] jlt-rounded-[2px] jlt-mt-2 jlt-px-5 jlt-outline-none jlt-text-sm jlt-text-[#3F475A]"
                    />
                </div>
                <div className="jlt-mb-6">
                    <label htmlFor="subject" className="jlt-block jlt-text-[#3F475A] jlt-text-sm">
                        Subject <RequiredStar />
                    </label>
                    <input
                        type="text"
                        name="subject"
                        id="subject"
                        value={formInfo.subject}
                        onChange={handleOnChange}
                        className="jlt-w-full jlt-h-[40px] jlt-bg-[#FCFDFF] jlt-border-[1px] jlt-border-[#EBEEF5] jlt-rounded-[2px] jlt-mt-2 jlt-px-5 jlt-outline-none jlt-text-sm jlt-text-[#3F475A]"
                    />
                </div>
                <div className="jlt-mb-6">
                    <label htmlFor="website" className="jlt-block jlt-text-[#3F475A] jlt-text-sm">
                        Website URL
                    </label>
                    <input
                        type="text"
                        name="website"
                        id="website"
                        value={formInfo.website}
                        onChange={handleOnChange}
                        className="jlt-w-full jlt-h-[40px] jlt-bg-[#FCFDFF] jlt-border-[1px] jlt-border-[#EBEEF5] jlt-rounded-[2px] jlt-mt-2 jlt-px-5 jlt-outline-none jlt-text-sm jlt-text-[#3F475A]"
                    />
                </div>
                <div className="jlt-mb-6">
                    <label htmlFor="message" className="jlt-block jlt-text-sm jlt-text-[#3F475A]">
                        Message <RequiredStar />
                    </label>
                    <textarea
                        name="message"
                        id="message"
                        value={formInfo.message}
                        onChange={handleOnChange}
                        className="jlt-w-full jlt-h-24 jlt-bg-[#FCFDFF] jlt-border-[1px] jlt-border-[#EBEEF5] jlt-rounded-[2px] jlt-mt-2 jlt-px-5 jlt-py-3 jlt-outline-none jlt-text-sm jlt-text-[#3F475A]"
                    />
                </div>

                <button
                    disabled={spinner}
                    onClick={handleSubmit}
                    className="jlt-h-[44px] jlt-py-3 jlt-px-6 jlt-bg-[#4CAF50] jlt-shadow-md jlt-shadow-[0px_0px_20px rgba(173, 173, 188, 0.15)] jlt-rounded-[25px] jlt-text-sm jlt-text-[#FFFFFF] jlt-font-bold">
                    Submit Query
                </button>
            </form>
        </div>
    );
};
